var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87677 4.80866C5.8899 4.63793 6.03226 4.5061 6.20349 4.5061C6.37184 4.5061 6.5128 4.63367 6.52955 4.80118L6.80004 7.5061L8.74005 8.61468C8.83898 8.67121 8.90004 8.77643 8.90004 8.89037C8.90004 9.09975 8.70095 9.25181 8.49896 9.19672L5.9987 8.51483C5.76732 8.45173 5.61334 8.23322 5.63173 7.9941L5.87677 4.80866Z",
    fill: "#FF9066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.901274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57621 1.16159C3.3121 0.84684 2.80216 0.967311 2.70683 1.36697L2.18428 3.5577C2.10661 3.88335 2.36468 4.19185 2.69893 4.17291L4.95255 4.0452C5.36346 4.02192 5.57184 3.53989 5.30729 3.22461L4.84931 2.67882C5.3735 2.4997 5.92933 2.40614 6.50007 2.40614C9.31673 2.40614 11.6001 4.68949 11.6001 7.50614C11.6001 10.3228 9.31673 12.6061 6.50007 12.6061C3.68342 12.6061 1.40007 10.3228 1.40007 7.50614C1.40007 7.0333 1.46411 6.57018 1.58896 6.12507L0.433553 5.80098C0.28143 6.3433 0.200073 6.91522 0.200073 7.50614C0.200073 10.9855 3.02068 13.8061 6.50007 13.8061C9.97947 13.8061 12.8001 10.9855 12.8001 7.50614C12.8001 4.02675 9.97947 1.20614 6.50007 1.20614C5.62489 1.20614 4.79138 1.3846 4.03396 1.70712L3.57621 1.16159Z",
    fill: "#FF9066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.da0b0a94d16a77085411884313cd6372.svg";
export { ForwardRef as ReactComponent };